import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  useReactFlow,
  EdgeProps,
  getStraightPath,
} from '@xyflow/react'
import React, { useState, useCallback } from 'react'

interface AnnotationEdgeProps extends EdgeProps {
  style?: React.CSSProperties
  markerEnd?: string
}

export default function AnnotationEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  source,
  target,
}: AnnotationEdgeProps) {
  const [edgePath, labelX, labelY] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  })
  //console.log('[AnnotationEdge] source:', source, 'target:', target)
  const [isHovered, setIsHovered] = useState(false)
  const { setNodes, setEdges } = useReactFlow()

  const deleteEdge = useCallback(
    (id: string) => {
      setEdges((eds) => eds.filter((e) => e.id !== id))
    },
    [setEdges]
  )

  const deleteNode = useCallback(
    (id: string) => {
      setNodes((nds) => {
        const nodeToDelete = nds.find((node) => node.id === id)
        if (nodeToDelete?.type === 'ghost') {
          return nds.filter((node) => node.id !== id) // Only delete ghost nodes
        }
        return nds // Do nothing if it's not a ghost node
      })

      setEdges((eds) => eds.filter((e) => e.source !== id && e.target !== id))
    },
    [setNodes, setEdges]
  )

  /*const deleteNode = useCallback(
    (id: string) => {
      setNodes((nds) => nds.filter((n) => n.id !== id))
      setEdges((eds) => eds.filter((e) => e.source !== id && e.target !== id))
    },
    [setNodes, setEdges]
  )*/

  const onEdgeClick = () => {
    //console.log('OnEdgeClick.id:', id, 'target', target)
    deleteEdge(id)
    deleteNode(target)
  }

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          strokeWidth: 1.75,
          stroke: '#bbb',
          transform: 'translate(0px, -15px)',
        }}
      />
      <path
        d={edgePath}
        fill="none"
        strokeOpacity={0}
        strokeWidth={20}
        strokeDasharray="none"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ pointerEvents: 'stroke' }}
      />

      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            pointerEvents: 'all',
          }}
          className="nodrag nopan"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <button
            className="edgebutton"
            onClick={onEdgeClick}
            style={{
              width: 20,
              height: 20,
              background: '#bababa22',
              border: '0.5px solid #80808099',
              color: '#00000075',
              borderRadius: '25%',
              fontSize: '16px',
              fontWeight: 100,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transform: 'translate(-2px, -15px)',
              opacity: isHovered ? 1 : 0,
              transition: 'opacity 0.2s ease-in-out',
              pointerEvents: 'all',
            }}
          >
            X
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  )
}
